import React from "react";
import { Helmet } from "react-helmet-async";
import "./style.css";
import Swal from "sweetalert2";
import { Redirect } from 'react-router-dom';
import { set_auth } from "../../reducers/Auth";
import { set_filter } from "../../reducers/Filter"
import { connect } from "react-redux";
import GoogleAuthButton from './components/googleauthbutton'
import LoginV2Img from "../../assets/images/login-v2.png"
import logo from "../../assets/images/full-logo.png"
import InfoIcon from "../../assets/icons/info-icon-green.svg"
import EyeGreyIcon from "../../assets/icons/eye-grey.svg"
import EyeSlashIcon from "../../assets/icons/eye-slash-grey.svg"
import CrossMarkIcon from "../../assets/icons/cross-mark.svg"
import GoogleAuthRemember from "./components/googleAuthRemember"
import OtpInput from "./components/OtpInput.js"

class LoginV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            messageEmail: "",
            messagePassword: "",
            messageOtp: "",
            messageSuccess: {
                header: "Berhasil",
                value: ""
            },
            messageFailed: {
                header: "Gagal",
                value: ""
            },
            otp: "",
            invalidEmail: false,
            invalidPassword: false,
            invalidOtp: false,
            disabledButton: false,
            hidePassword: true,
            confirmOtp: false,
            remember_me: false,
            otpCountdown: 300, // 5 minutes in seconds
            otpExpired: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitAuth = this.submitAuth.bind(this);
        this.submitAuthR = this.submitAuthR.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleOtpChange = this.handleOtpChange.bind(this);
        this.countdownInterval = null;
    }

    login = () => {
    }

    handleChange(event) {
        const name = event.target.name
        const value = event.target.value

        this.setState({
            [name]: value
        })
    }

    handleCheckBox = () => {
        this.setState((prevState) => ({
            remember_me: !prevState.remember_me
        }));
    }

    handleOtpChange = (otpValue) => {
        this.setState({
            otp: otpValue,
            invalidOtp: false,
            messageOtp: ""
        });
    }

    startOtpCountdown = () => {
        this.setState({
            otpCountdown: 300, // Reset to 5 minutes
            otpExpired: false
        });

        // Clear any existing interval
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        this.countdownInterval = setInterval(() => {
            this.setState((prevState) => {
                const newCountdown = prevState.otpCountdown - 1;

                if (newCountdown <= 0) {
                    clearInterval(this.countdownInterval);
                    return {
                        otpCountdown: 0,
                        otpExpired: true
                    };
                }

                return { otpCountdown: newCountdown };
            });
        }, 1000);
    }

    formatCountdown = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    submitAuth = (event) => {
        event.preventDefault()
        this.setState({
            disabledButton: true,
            messageFailed: {
                header: "",
                value: ""
            },
            messageSuccess: {
                header: "",
                value: ""
            }
        })

        let form = {
            perusahaan_email: this.state.email,
            perusahaan_password: this.state.password,
            perusahaan_otp: this.state.otp,
        }
        this.props.request("login", form)
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        showConfirmButton: false,
                        icon: 'success',
                    })
                    this.props.set_auth(response.api_token, response.data);
                    this.props.set_filter(response.all_data)
                    window.location.reload(false);
                }

                if (response && response.failed) {
                    this.setState({
                        messageFailed: {
                            header: "Gagal",
                            value: response.message
                        }
                    })
                }
                this.setState({
                    disabledButton: false
                })
            });
    }

    submitAuthR = (event) => {
        event.preventDefault()
        this.setState({
            disabledButton: true,
            messageFailed: {
                header: "",
                value: ""
            },
            messageSuccess: {
                header: "",
                value: ""
            }
        })

        let form = {
            perusahaan_email: this.state.email,
            perusahaan_password: this.state.password,
            perusahaan_otp: this.state.otp,
        }
        this.props.request("remember", form)
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        showConfirmButton: false,
                        icon: 'success',
                    })
                    this.props.set_auth(response.api_token, response.data);
                    window.location.reload(false);
                }

                if (response && response.failed) {
                    this.setState({
                        messageFailed: {
                            header: "Gagal",
                            value: response.message
                        }
                    })
                }
                this.setState({
                    disabledButton: false
                })
            });
    }

    submitGoogleLogin(access_token) {
        let form = {
            token: access_token,
        }

        this.props.request("login-google", form)
            .then(response => {
                if (response && response.success) {
                    this.props.set_auth(response.api_token, response.data);
                    this.props.set_filter(response.all_data)
                    window.location.reload(false);
                } else if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'Daftar Sekarang',
                        showCancelButton: true,
                        cancelButtonText: 'Batal',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                loading: false,
                                success: true,
                                data: response.data
                            });

                            this.props.history.push({
                                pathname: '/register',
                                state: { userData: response.data }
                            });
                            window.location.reload(true);
                        }
                    })
                }
            })
    }

    submitGoogleRemember(access_token) {
        let form = {
            token: access_token,
        }
        this.props.request("google_remember_login", form)
            .then(response => {
                if (response && response.success) {
                    this.props.set_auth(response.api_token, response.data);
                    window.location.reload(false);
                } else if (response && response.failed) {
                    this.setState({
                        messageFailed: {
                            header: "Gagal",
                            value: response.message
                        }
                    })
                }
            })
    }

    submitLoginRemember = (event) => {
        Swal.fire({
            title: 'Peringatan!',
            text: `Apakah Anda yakin ingin mengaktifkan opsi "Ingat Saya"? Dengan mengaktifkan opsi ini, informasi login Anda akan disimpan pada perangkat ini selama 1 bulan, sehingga Anda tidak perlu memasukkan kredensial Anda setiap kali Anda mengakses akun Anda.`,
            confirmButtonText: 'Lanjutkan',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            icon: 'warning',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        disabledButton: true,
                        messageFailed: {
                            header: "",
                            value: ""
                        },
                        messageSuccess: {
                            header: "",
                            value: ""
                        }
                    })
                    if (this.state.email === "") {
                        this.setState({
                            invalidEmail: true,
                            messageEmail: "Email wajib diisi!"
                        })
                    } else if (this.state.password === "") {
                        this.setState({
                            invalidPassword: true,
                            messagePassword: "Password Wajib diisi!"
                        })
                    }
                    let form = {
                        perusahaan_email: this.state.email,
                        perusahaan_password: this.state.password,
                    }
        this.props.request("req_code", form)
            .then(response => {
                if (response && response.success) {
                                this.setState({
                                    confirmOtp: true,
                                    messageSuccess: {
                                        header: "OTP Telah dikirim ke Email anda",
                                        value: response.message || "Silahkan cek email anda dan masukkan OTP tersebut. Kode OTP berlaku selama 5 menit."
                                    }
                                })
                                this.startOtpCountdown();
                            } else if (response && response.skip_otp) {
                                this.submitAuthR(event)
                            } else if (response && response.failed) {
                                this.setState({
                                    messageFailed: {
                                        header: "Gagal",
                                        value: response.message
                                    }
                                })
                            }
                            this.setState({
                                disabledButton: false
                            })
                        })
                }
            })
    }

    submitLogin = (event) => {
        this.setState({
            disabledButton: true,
            messageFailed: {
                header: "",
                value: ""
            },
            messageSuccess: {
                header: "",
                value: ""
            }
        })
        if (this.state.email === "") {
            this.setState({
                invalidEmail: true,
                messageEmail: "Email wajib diisi!",
                disabledButton: false
            })
            return;
        } else if (this.state.password === "") {
            this.setState({
                invalidPassword: true,
                messagePassword: "Password Wajib diisi!",
                disabledButton: false
            })
            return;
        }
        let form = {
            perusahaan_email: this.state.email,
            perusahaan_password: this.state.password,
        }

        this.props.request("req_code", form)
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        confirmOtp: true,
                        messageSuccess: {
                            header: "OTP Telah dikirim ke Email anda",
                            value: response.message || "Silahkan cek email anda dan masukkan OTP tersebut. Kode OTP berlaku selama 5 menit."
                        }
                    })
                    this.startOtpCountdown();
                } else if (response && response.skip_otp) {
                    this.submitAuth(event)
                } else if (response && response.failed) {
                    this.setState({
                        messageFailed: {
                            header: "Gagal",
                            value: response.message
                        }
                    })
                }
                this.setState({
                    disabledButton: false
                })
            });
    }

    resendOtp = () => {
        this.setState({
            disabledButton: true,
            otp: "",
            messageFailed: {
                header: "",
                value: ""
            },
            messageSuccess: {
                header: "",
                value: ""
            }
        })

        let form = {
            perusahaan_email: this.state.email,
            perusahaan_password: this.state.password,
        }

        this.props.request("req_code", form)
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        messageSuccess: {
                            header: "OTP Berhasil Dikirim Ulang",
                            value: response.message || "Kode OTP baru telah dikirim ke email Anda."
                        }
                    })
                    this.startOtpCountdown();
                } else if (response && response.failed) {
                    this.setState({
                        messageFailed: {
                            header: "Gagal",
                            value: response.message
                        }
                    })
                }
                this.setState({
                    disabledButton: false
                })
            });
    }

    checkToken() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        const getparam = urlSearchParams.get('token')

        if(getparam) {
            let formData = {
                token: getparam
            }
            this.props.request('check_token', formData, 'POST')
                .then(response => {
                    if (response && response.success) {
                        this.props.set_auth(response.api_token, response.data);
                        this.props.set_filter(response.all_data)
                        window.location.reload(false);
                    }
                    this.setState({loading: false})
                })
        }
    }

    componentDidMount() {
        if (this.props.location.state !== undefined) {
            if (this.props.location.state.success) {
                this.setState({
                    messageSuccess: {
                        header: "Berhasil",
                        value: this.props.location.state.message
                    }
                }, () => this.props.history.push({ state: undefined }))
            }
        }
        this.checkToken()
    }

    render() {
        let redirect;
        if (this.props.auth) {
            const {location} = this.props;

            if (typeof location.state !== 'undefined' && location.state.from.pathname !== '/login') {
                redirect = location.state.from.pathname;
            }
            else {
                redirect = '/dashboard';
            }

            return <Redirect to={redirect} />
        }
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Login - Presensi</title>
                    <meta name="description" content="Detail Absensi" />
                </Helmet>
                <div className="container-fluid">
                    <div className="row flex-row-reverse">
                        <div className="col-md-8 p-0">
                            <div className="loginv2-div-img">
                                <img alt="" src={LoginV2Img} className="loginv2-img" />
                            </div>
                        </div>
                        <div className="col-md-4 loginv2-col-form">
                            <div className="row loginv2-row-logo">
                                <div className="col-md-12" style={{ textAlign: "center" }}>
                                    <img alt="" src={logo} />
                                </div>
                            </div>
                            {this.state.messageFailed.value !== "" &&
                                <div className="row">
                                    <div className="col-md-12 loginv2-row-form">
                                        <div className="d-flex flex-row loginv2-failed">
                                            <div>
                                                <img alt="" src={CrossMarkIcon} style={{ width: "24px", height: "24px" }} />
                                            </div>
                                            <div className="pl-2">
                                                <div style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,
                                                    lineHeight: "18px"
                                                }}>{this.state.messageFailed.header}</div>
                                                <div>{this.state.messageFailed.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.state.messageSuccess.value !== "" &&
                                <div className="row">
                                    <div className="col-md-12 loginv2-row-form">
                                        <div className="d-flex flex-row loginv2-success">
                                            <div>
                                                <img alt="" src={InfoIcon} style={{ width: "24px", height: "24px" }} />
                                            </div>
                                            <div className="pl-2">
                                                <div style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,
                                                    lineHeight: "18px"
                                                }}>{this.state.messageSuccess.header}</div>
                                                <div>{this.state.messageSuccess.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-md-12 text-center loginv2-masuk-akun">
                                    Masuk akun
                                </div>
                            </div>
                            {this.state.confirmOtp ?
                                <>
                                    <div className="row loginv2-row-form">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="loginv2-label">Masukkan Kode OTP</label>
                                                <OtpInput
                                                    length={6}
                                                    value={this.state.otp}
                                                    onChange={this.handleOtpChange}
                                                />
                                                {this.state.invalidOtp &&
                                                    <div className="text-danger text-center mt-2" style={{fontSize: "14px"}}>
                                                        {this.state.messageOtp}
                                                    </div>
                                                }
                                                <div className="text-center mt-3">
                                                    {this.state.otpExpired ? (
                                                        <span className="text-danger" style={{fontSize: "14px", fontWeight: "600"}}>
                                                            Kode OTP telah kadaluarsa
                                                        </span>
                                                    ) : (
                                                        <span style={{fontSize: "14px", color: "#6c757d"}}>
                                                            Kode berlaku selama: <strong>{this.formatCountdown(this.state.otpCountdown)}</strong>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-2">
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-primary btn-block loginv2-button-login"
                                                disabled={this.state.otp.length !== 6 || this.state.disabledButton || this.state.otpExpired}
                                                onClick={this.state.remember_me ? this.submitAuthR : this.submitAuth}>
                                                Konfirmasi OTP
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-4">
                                        <div className="col-md-12 text-center">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                style={{color: "#057CE4", textDecoration: "none", fontSize: "14px"}}
                                                disabled={this.state.disabledButton}
                                                onClick={this.resendOtp}>
                                                Kirim Ulang Kode OTP
                                            </button>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div className="row loginv2-row-form">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="loginv2-label">Email</label>
                                                <input className={this.state.invalidEmail ? "form-control is-invalid loginv2-input" : "form-control loginv2-input"} placeholder="emailanda@gmail.com" name="email" onChange={this.handleChange} type="text" value={this.state.email} />
                                                {this.state.invalidEmail &&
                                                    <div className="invalid-feedback loginv2-invalid">
                                                        {this.state.messageEmail}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-4">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="loginv2-label">Password</label>
                                                <div className="input-group">
                                                    <input
                                                        className={this.state.invalidPassword ? "form-control is-invalid loginv2-input" : "form-control loginv2-input"}
                                                        placeholder="Masukkan password" style={{borderRight: "none"}}
                                                        name="password" onChange={this.handleChange}
                                                        type={this.state.hidePassword ? "password" : "text"}
                                                        value={this.state.password} onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            this.submitLogin(e)
                                                        }
                                                    }}/>
                                                    {this.state.invalidPassword &&
                                                        <div className="invalid-feedback loginv2-invalid">
                                                            {this.state.messagePassword}
                                                        </div>
                                                    }
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                            <img className="loginv2-input-icon" style={{
                                                                width: "16px",
                                                                height: "16px",
                                                                backgroundColor: "#E9ECEF"
                                                            }} alt=""
                                                                 src={this.state.hidePassword ? EyeGreyIcon : EyeSlashIcon}
                                                                 onClick={() => this.setState({
                                                                     hidePassword: !this.state.hidePassword
                                                                 })}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between align-content-center">
                                                    <label htmlFor="remember_me"
                                                           className="d-inline-flex flex-row align-items-center pt-1"
                                                           style={{
                                                               display: "flex",
                                                               alignItems: "center",
                                                               gap: "3px",
                                                               width: "fit-content",
                                                               fontSize: "12px"
                                                           }}>
                                                        <input id="remember_me" type="checkbox" name="remember_me"
                                                               onChange={this.handleCheckBox}
                                                               checked={this.state.remember_me}
                                                        />
                                                        Ingat Saya</label>
                                                    <a href="/lupa-password"
                                                       className="form-text float-right loginv2-lupa-password">Lupa
                                                        password?</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-2">
                                        <div className="col-md-12">
                                            <button className="btn btn-primary btn-block loginv2-button-login"
                                                    disabled={this.state.email === "" || this.state.password === "" || this.state.disabledButton}
                                                    onClick={this.state.remember_me ? (e) => this.submitLoginRemember(e) :
                                                        (e) => this.submitLogin(e)}>Masuk sekarang
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-2">
                                        <div className="col-md-12">
                                            {this.state.remember_me ?
                                                <GoogleAuthRemember action={(access_token) => {
                                                    this.submitGoogleRemember(access_token)
                                                }}/>
                                                :
                                                <GoogleAuthButton action={(access_token) => {
                                                    this.submitGoogleLogin(access_token)
                                                }}/>
                                            }
                                        </div>
                                    </div>
                                    <div className="row loginv2-row-form mb-4">
                                        <div className="col-md-12">
                                            <div className="loginv2-info">Belum punya akun? <a href="/register" style={{color: "#057CE4"}}>Daftar disini</a></div>
                                            <div className="loginv2-info">Jika ingin menghapus karyawan! <a
                                                href="/hapus-karyawan" style={{color: "#ff0000"}}>Hapus disini</a></div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    api_token: state.Auth.api_token,
    data: state.Auth.data,
    all_data: state.Filter.all_data
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data, all_data) => dispatch(set_auth(api_token, data, all_data)),
    set_filter: (all_data) => dispatch(set_filter(all_data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginV2);
